module.exports = __webpack_public_path__ + "img/P150T_weapon_142.f9f5f200.png";